// src/js/components/Evaluation/Results.js
import React, { Component } from "react";

class BenchmarkBarArrow extends Component {
    render() {
        // half our text width is this.props.textwidth/2

        let display = {left: ((this.props.textwidth/2) - 6)+'px'};
        let thisposition = {left: `${this.props.positionwidth}px`};
        let arrowclass = "evBenchmarkBarArrowPoint";
        let textdisplay = {};

        if (this.props.positionwidth < 0) {
            display = {left: "-6px"};
            textdisplay = {left: "-6px"};
            thisposition = {left: `${(this.props.positionwidth + (this.props.textwidth/2))}px` };
        }

        if (this.props.positionwidth >= (this.props.elementwidth - (this.props.textwidth))) {
            display = {right: "-6px"};
            textdisplay = {right: "-6px"};
            thisposition = {left: `${(this.props.positionwidth + (this.props.textwidth/2))}px` };
        }

        if (this.props.percentage === 0) {
            display = {left: 0};
            textdisplay = {};
            arrowclass = "evBenchmarkBarArrowPointLeft";
        }

        if (this.props.percentage === 100) {
            display = {right: 0};
            textdisplay = {right: 0};
            arrowclass = "evBenchmarkBarArrowPointRight";
        }

        return(
            <div className="evBenchmarkBarArrow" style={thisposition}>
                <div className="evBenchmarkBarArrowText" id="evBenchmarkBarArrow" style={textdisplay}>Your&nbsp;Response</div>
                <div className={arrowclass} style={display}></div>
            </div>
        )
    }

}

export default BenchmarkBarArrow;